import { render, staticRenderFns } from "./historicalLog.vue?vue&type=template&id=395eaf77"
import script from "./historicalLog.vue?vue&type=script&lang=js"
export * from "./historicalLog.vue?vue&type=script&lang=js"
import style0 from "./historicalLog.vue?vue&type=style&index=0&id=395eaf77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports